module.exports = __webpack_public_path__ + "static/media/lojal.b3e09765.mp3";